'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _StringColumn2 = require('./StringColumn');

var _StringColumn3 = _interopRequireDefault(_StringColumn2);

var _globalize = require('globalize');

var _globalize2 = _interopRequireDefault(_globalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var log = require('debug')('linksoft:datatables:NumericColumn');

var NumericColumn = function (_StringColumn) {
	_inherits(NumericColumn, _StringColumn);

	function NumericColumn() {
		_classCallCheck(this, NumericColumn);

		return _possibleConstructorReturn(this, (NumericColumn.__proto__ || Object.getPrototypeOf(NumericColumn)).apply(this, arguments));
	}

	_createClass(NumericColumn, [{
		key: 'getNumber',
		value: function getNumber(value) {
			if (typeof value === 'string') {
				value = this.isFloat ? parseFloat(value) : parseInt(value, 10);
			}
			return isNaN(value) ? null : value;
		}
	}, {
		key: 'displayValue',
		value: function displayValue(value) {
			var number = this.getNumber(value);
			return typeof number === 'number' && !isNaN(number) ? this._getFormattedValue(value) : _StringColumn2.noValue;
		}
	}, {
		key: '_getFormattedValue',
		value: function _getFormattedValue(value) {
			var formatted = _globalize2.default.format(value, this.options.formatString);
			return typeof formatted === 'string' ? formatted.replace(' ', '&nbsp;') : formatted;
		}
	}, {
		key: 'createEditor',
		value: function createEditor(value) {
			if (typeof value === 'number') {
				value = '' + value;
			}
			return (0, _jquery2.default)('<input class="table-input" type="number" step="' + (this.isFloat ? 0.01 : 1) + '"/>').val(value || '').get(0);
		}
	}, {
		key: 'getEditorValue',
		value: function getEditorValue(cellElement) {
			var inputValue = _get(NumericColumn.prototype.__proto__ || Object.getPrototypeOf(NumericColumn.prototype), 'getEditorValue', this).call(this, cellElement);

			if (this.isFloat) {
				// TODO: make comma and dot decimal separator based on which is the last, remove all others non-digits
			}

			if (!inputValue) return null;
			try {
				return this.getNumber(inputValue);
			} catch (error) {
				log('An error occured while getting value from table cell editor. %o', error);
			}
			return inputValue;
		}

		// -------------- FILTERS --------------------

	}, {
		key: 'createFilter',
		value: function createFilter() {
			return '<div class="input-group">\n\t<input type="number" class="form-control input-sm table-filter" step="' + (this.isFloat ? 0.01 : 1) + '">\n\t<span class="input-group-addon">-</span>\n\t<input type="number" class="form-control input-sm table-filter" step="' + (this.isFloat ? 0.01 : 1) + '">\n</div>';
		}
	}, {
		key: 'buildFilterExpression',
		value: function buildFilterExpression(fieldName, columnFilter) {
			// Currently, we cannot use global search for date and numeric fields (exception on the OData service side)
			// However, individual column filters are supported in form lower~upper
			if (columnFilter.indexOf("~") > -1) {
				var ranges = columnFilter.split("~");
				var rangeQuery = [];
				if (ranges[0]) {
					rangeQuery.push("(" + fieldName + " ge " + ranges[0] + ")");
				}
				if (ranges[1]) {
					rangeQuery.push("(" + fieldName + " le " + ranges[1] + ")");
				}
				return "(" + rangeQuery.join(" and ") + ")";
			} else {
				return "(" + fieldName + " eq " + columnFilter + ")";
			}
		}
	}, {
		key: 'exportRender',
		value: function exportRender(value, row, meta) {
			return value;
		}
	}, {
		key: 'isFloat',
		get: function get() {
			return this.options.type === 'float';
		}
	}]);

	return NumericColumn;
}(_StringColumn3.default);

exports.default = NumericColumn;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/NumericColumn.js
// module id = 490
// module chunks = 0